import { useRef, useState } from "react";
import { api } from "@/lib/api";
import { useMe } from "@/app/MeContext";
import type { Me } from "@/lib/types";
import { Button, Card, PageHeader, toast } from "@/components/ui";
import { RichEditor, type RichEditorHandle } from "@/components/RichEditor";

/** Per-user settings. Today: the email signature. Each user edits only their own. */
export function SettingsPage() {
  const me = useMe();
  const editor = useRef<RichEditorHandle>(null);
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState<string | null>(me.signature);
  const save = async () => {
    setBusy(true);
    try {
      const r = await api.patch<Me>("/me", { signature: editor.current?.getHtml() ?? "" });
      setSaved(r.signature);
      me.refresh();
      toast(r.signature ? "Signature saved" : "Signature cleared");
    } catch (e) { toast((e as Error).message, true); } finally { setBusy(false); }
  };
  const starter = () => editor.current?.setHtml(`<div>${me.name}</div><div>HixonOps</div><div><a href="https://hixonops.com">hixonops.com</a></div>`);
  return (
    <>
      <PageHeader title="Settings" sub={me.email} />
      <div className="page two-col">
        <div className="left">
          <Card title="Email signature" actions={<><button className="btn-link small muted" onClick={starter}>Use a starter</button><Button variant="primary" disabled={busy} onClick={save}>Save</Button></>}>
            <div className="card-body small muted-2">Added under every new email and reply you write. You can delete or change it in the message before sending. Bold, italic and links are kept; pasted text comes in plain.</div>
            <div className="reply-box" style={{ margin: "0 16px 16px" }}>
              <RichEditor ref={editor} placeholder="Name, title, phone, website…" initialHtml={me.signature ?? ""} minHeight={120} />
            </div>
          </Card>
        </div>
        <div className="right">
          <Card title="Preview">
            {saved ? <div className="card-body prose" style={{ color: "var(--text-body)" }} dangerouslySetInnerHTML={{ __html: saved }} /> : <div className="empty">No signature saved yet.</div>}
          </Card>
          <Card title="Account">
            <div className="card-body"><dl className="kv"><dt>Name</dt><dd>{me.name}</dd><dt>Email</dt><dd>{me.email}</dd><dt>Role</dt><dd>{me.role === "admin" ? "Admin" : "Member"}</dd></dl></div>
            <div className="card-body xs muted">Name, email and sign-in are managed by an admin under Admin → Users.</div>
          </Card>
        </div>
      </div>
    </>
  );
}
